import React from 'react';
export function CropIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.994 16.013h-3l.01-7a3 3 0 00-3-3l-7-.011v-3a1 1 0 00-1-1 1 1 0 00-1 1v3h-3a1 1 0 000 2h3l-.01 7a3 3 0 002.995 3l7 .011v3a1 1 0 002 0v-3h3a1 1 0 000-2h.005zm-12-.013a1 1 0 01-1-1l.01-7 7 .01a1 1 0 011 1l-.01 7.001-7-.011z"
  }));
}